// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

type InvestmentBalanceTypeV2 = {
  id: string,
  createdAt: ?string,
  accountId: string,
  balanceOn: string,
  balance: number,
  cashBalance: number,
  isDeleted: ?boolean,
};

export type InvestmentBalanceV2 = RecordOf<InvestmentBalanceTypeV2>;
export const mkInvestmentBalanceV2: RecordFactory<InvestmentBalanceV2> =
  Record({
    id: undefined,
    createdAt: undefined,
    accountId: undefined,
    balanceOn: undefined,
    balance: undefined,
    cashBalance: undefined,
    isDeleted: undefined,
  });
